import { render } from "./ObjectRenderer.vue?vue&type=template&id=2cfbdc06&ts=true"
import script from "./ObjectRenderer.vue?vue&type=script&lang=ts"
export * from "./ObjectRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__